module.exports = __webpack_public_path__ + "static/poster-d36216391dfb696340956e70593fe534.jpg";